import { PolicyCard } from '@/components/molecule/PolicyCard';

interface RelatedPolicy {
  id?: number;
  idIdx?: string;
  title?: string;
  agencyLogo?: string;
  agency?: string;
  benefit?: string;
  isBookmarked?: boolean;
  dDay?: string;
  endAt?: string;
}

interface RelatedPolicyListProps {
  relatedPolicyList?: RelatedPolicy[];
}

export const RelatedPolicyList = ({
  relatedPolicyList,
}: RelatedPolicyListProps) => {
  return (
    <ul className="m-0 flex flex-col gap-16 p-20">
      {relatedPolicyList?.map((relatedPolicy) => {
        return (
          <li
            key={relatedPolicy.idIdx}
            className="overflow-hidden rounded-small"
          >
            <PolicyCard
              border
              benefit={relatedPolicy.benefit}
              dday={relatedPolicy.dDay}
              endAt={relatedPolicy.endAt}
              id={relatedPolicy.id}
              idIdx={relatedPolicy.idIdx}
              imageUrl={relatedPolicy.agencyLogo}
              isBookmarked={relatedPolicy.isBookmarked}
              name={relatedPolicy.title}
              agency={relatedPolicy.agency}
            />
          </li>
        );
      })}
    </ul>
  );
};
